<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13V33Kh/tc-custom/9781429988452.jpg?1737766940410" alt="This image is the cover for the book The Mad Scientist's Guide to World Domination"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Mad Scientist's Guide to World Domination
      </h1>
      <p class="bookDescription body article font2">
        <b>“A no-holds-barred collection” of evil genius stories from Diana Gabaldon, Grady Hendrix, Austin Grossman, Naomi Novik, and eighteen other popular writers (<i>Library Journal</i>, starred review).</b><br/><br/>From Victor Frankenstein to Lex Luthor, from Dr. Moreau to Dr. Doom, readers have long been fascinated by insane plans for world domination and the madmen who devise them.<br/><br/>Typically, we see these villains through the eyes of good guys. This anthology, <i>The Mad Scientist’s Guide to World Domination</i>, however, explores the world of mad scientists and evil geniuses—from their own wonderfully twisted point of view.<br/><br/>An all-star roster of bestselling authors—including Diana Gabaldon, Daniel Wilson, Austin Grossman, Naomi Novik, and Seanan McGuire . . . twenty-two great storytellers all told—have produced a fabulous assortment of stories guaranteed to provide readers with hour after hour of high-octane entertainment born of the most megalomaniacal mayhem imaginable.<br/><br/>Everybody loves villains. They’re bad; they always stir the pot; they’re much more fun than the good guys, even if we want to see the good guys win. Their fiendish schemes, maniacal laughter, and limitless ambition are legendary, but what lies behind those crazy eyes and wicked grins? How—and why—do they commit these nefarious deeds? And why are they so set on taking over the world?<br/><br/>If you’ve ever asked yourself any of these questions, you’re in luck: It’s finally time for the madmen’s side of the story.<br/><br/><b>“Veteran anthology editor Adams succeeds again . . . [His] entertaining story introductions set the stage for villains to find their own definitions and identities.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diana Gabaldon, John Joseph Adams, Austin Grossman, Seanan McGuire
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15176df3